import { useTranslation } from 'react-i18next';
import { Button } from 'components/Button';
import { Heading, Paragraph } from 'components/Typography';
import { ScheduleContext, withScheduleMachineState } from 'domains/signup/consultationSchedule/data/ScheduleContext';
import { TIME } from 'utils/date';
import { useDisplayTimezone } from 'domains/timezone/useDisplayTimezone';
import { addMinutes } from 'date-fns';
import { AppointmentDate } from 'components/AppointmentDate';

const ConfirmConsultationDate: React.FC = () => {
  const consultationDate = ScheduleContext.useSelector(({ context }) => context.consultationDate);
  const { send } = ScheduleContext.useActorRef();

  const { format } = useDisplayTimezone();
  const { t } = useTranslation();

  return (
    <>
      <Heading level="h2" className="mb-64 sm-d:mb-40 text-left">
        {t(`consultation.schedule.confirm.title`)}
      </Heading>

      <AppointmentDate date={consultationDate as Date} className="mb-64 sm-d:mb-40" />

      {consultationDate && (
        <Paragraph className="mb-64 sm-d:mb-40">
          {t('consultation.schedule.confirm.helpText', {
            time: format(consultationDate, TIME),
            tenMinutesWindowTime: format(addMinutes(consultationDate, 10), TIME),
          })}
        </Paragraph>
      )}

      <div className="flex sm-d:flex-col gap-16">
        <Button
          data-testid="consultation-date-submit-button"
          size="lg"
          onClick={() =>
            send({
              type: 'confirmedConsultationDate',
            })
          }
        >
          {t('consultation.schedule.confirm.submit')}
        </Button>
        <Button
          size="lg"
          variant="ghost"
          onClick={() =>
            send({
              type: 'back',
            })
          }
        >
          {t('consultation.schedule.confirm.back')}
        </Button>
      </div>
    </>
  );
};

export const ScheduleConfirmConsultationDate = withScheduleMachineState(
  ConfirmConsultationDate,
  'confirmConsultationDate',
);
